export function createStandings(participants) {
  return participants.reduce((acc, identity) => {
    if (!identity) {
      return acc
    }
    acc[identity] = {
      played: 0,
      won: 0,
      lost: 0,
      points: 0,
      pf: 0,
      pa: 0,
      diff: 0,
    }
    return acc
  }, {})
}

export function applyMatchResult(standings, result) {
  const next = { ...standings }
  const p1 = next[result.player1Identity]
  const p2 = next[result.player2Identity]

  if (!p1 || !p2) {
    return next
  }

  p1.played += 1
  p2.played += 1

  p1.pf += result.score1
  p1.pa += result.score2
  p1.diff = p1.pf - p1.pa

  p2.pf += result.score2
  p2.pa += result.score1
  p2.diff = p2.pf - p2.pa

  if (result.winnerIdentity === result.player1Identity) {
    p1.won += 1
    p2.lost += 1
    p1.points += 3
  } else if (result.winnerIdentity === result.player2Identity) {
    p2.won += 1
    p1.lost += 1
    p2.points += 3
  }

  return next
}
